import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React, { useState } from "react";
import CustomPagination from "../../../../components/CustomPagination";
import Modal from "../../../../components/Modal";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {ReactComponent as RemoveRedEyeOutlinedIcon} from "../../../../assets/AccountingModule/view.svg";
import styles from "./style";
import { Edit } from "@mui/icons-material";

const StaffList = ({data}) => {
  const [open, setOpen] = useState(false)
  return(
    <>   
      <TableContainer  sx={styles.noShadow}>
        <Table  >
          <TableHead>
            <TableRow>
              <TableCell sx={styles.tableHead}>#</TableCell>
              <TableCell sx={styles.tableHead}>Name</TableCell>
              <TableCell sx={styles.tableHead}>Employee ID</TableCell>
              <TableCell sx={styles.tableHead}>Designation</TableCell>
              <TableCell sx={styles.tableHead}>Employee Id</TableCell>
              <TableCell sx={styles.tableHead}>Action</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {!data ? ( 
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : ( 
              data?.map((item, index) => (
                <TableRow key={index} sx={{verticalAlign:"baseline"}}>
                  <TableCell sx={styles.tabledata}>{index+1} </TableCell>
                  <TableCell sx={styles.tabledata}>{item?.title?.length > 15 ? `${item?.title?.slice(0,15)}...`:item?.title}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.category > 15 ? `${item?.category?.slice(0,15)}...`:item?.category}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.supplierName?.length > 15 ? `${item?.supplierName?.slice(0,15)}...`:item?.supplierName}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.quantity}</TableCell>

                  <TableCell sx={styles.actionData}>
                    <Box ><Edit /></Box>
                    <Box ><RemoveRedEyeOutlinedIcon /></Box>
                    <Box onClick={() => {setOpen(true);}}><DeleteOutlineIcon sx={{ color: "#ff0000" }}  /></Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>

        </Table>
    
        <CustomPagination/>

      </TableContainer>


      <Modal open={open} setOpen={setOpen} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Item"} >
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>

        </Box>
      </Modal>    </> 
  )
}

export default StaffList